import useReveal from "@/hooks/useReveal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What is LumeroFlow?",
    a: "LumeroFlow is a clinic software platform that combines appointment scheduling, patient records, invoicing, and AI-powered consultation documentation in one connected workflow. It's built for private clinics that want to streamline both operations and clinical note-taking.",
  },
  {
    q: "Is LumeroFlow for all clinics?",
    a: "LumeroFlow is designed primarily for private clinics and practices, including osteopaths, physiotherapists, chiropractors, therapists, and similar healthcare professionals. If your clinic manages appointments and clinical notes, LumeroFlow is built for you.",
  },
  {
    q: "Do clinicians approve notes before saving?",
    a: "Yes. AI-generated notes are always presented as drafts for the clinician to review, edit, and approve before they are saved to the patient record. Clinicians remain in full control of their documentation.",
  },
  {
    q: "Can clinics use LumeroFlow for appointments and records too?",
    a: "Absolutely. LumeroFlow is a full clinic management platform. Beyond AI consultation notes, it includes scheduling, patient records, visit history, document storage, and invoicing, all connected in one system.",
  },
  {
    q: "Is LumeroFlow suitable for private practices?",
    a: "Yes, LumeroFlow is specifically designed for private practices. Whether you're a solo practitioner or managing a multi-clinician practice, the platform adapts to your workflow and scales with your needs.",
  },
];

const FAQSection = () => {
  const [ref, isVisible] = useReveal();

  return (
    <section
      ref={ref}
      data-testid="faq-section"
      className="py-20 md:py-32"
      style={{ backgroundColor: "#F3F2EE" }}
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12">
        <div className={`text-center mb-14 reveal-section ${isVisible ? "visible" : ""}`}>
          <p className="text-sm font-medium uppercase tracking-[0.2em] text-[#205B5A] mb-5">
            FAQ
          </p>
          <h2
            data-testid="faq-heading"
            className="text-3xl sm:text-4xl md:text-5xl font-medium tracking-tight leading-tight text-[#1A1B1A]"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            Frequently asked questions
          </h2>
        </div>

        <div className={`reveal-section ${isVisible ? "visible" : ""}`} style={{ transitionDelay: "0.15s" }}>
          <Accordion type="single" collapsible defaultValue="item-0" className="w-full">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b border-[#1A1B1A]/[0.08] first:border-t-0"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger
                  className="py-7 text-left text-base md:text-lg font-medium text-[#1A1B1A] hover:no-underline hover:text-[#205B5A] transition-colors"
                  style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
                  data-testid={`faq-trigger-${i}`}
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4A4B4A] text-sm md:text-base leading-relaxed pb-7">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
